import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  formTypesLength: 0,
  formTypes: [],
  formType: {},
  formTypeError: "",
  formError: "",
};

export default function FormTypeReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_FORM_TYPE:
      return { ...state, loading: action.payload };
    case actions.LOADING_FORM_TYPE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_FORM_TYPE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FORM_TYPE:
      return {
        ...state,
        formTypes: action.payload.formTypes,
        formTypesLength: action.payload.formTypesLength,
      };
    case actions.GET_FORM_TYPE_BY_ID:
      return {
        ...state, formType: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_TYPE_FAIL:
      return { ...state, formTypeError: action.payload };
    default:
      return state;
  }
}
